<template>
  <el-row>
    <el-col :span="24">
      <h3 class="form-title">
        {{ id ? "Huquqiy hujjatni tahrirlash" : "Huquqiy hujjat qo'shish" }}
      </h3>
    </el-col>
    <el-col :span="24">
      <el-form
        v-loading="loading"
        label-position="top"
        ref="formRef"
        :model="form"
        class="legal-form"
      >
        <el-form-item
          label="Sarlavha (O'zbekcha lotin)"
          prop="title.uz_lat"
          :rules="[{ required: true, message: 'Sarlavhani kiriting' }]"
        >
          <el-input v-model="form.title.uz_lat" placeholder="O'zbek tilidagi sarlavha" />
        </el-form-item>

        <el-form-item label="Sarlavha (Rus tili)" prop="title.ru">
          <el-input v-model="form.title.ru" placeholder="Rus tilidagi sarlavha" />
        </el-form-item>

        <el-form-item label="Sarlavha (Ingliz tili)" prop="title.en">
          <el-input v-model="form.title.en" placeholder="Ingliz tilidagi sarlavha" />
        </el-form-item>

        <el-form-item label="Sarlavha (O'zbekcha kirill)" prop="title.uz_cyr">
          <el-input v-model="form.title.uz_cyr" placeholder="Kirill yozuvidagi sarlavha" />
        </el-form-item>

        <el-form-item label="Sarlavha (Qoraqalpoqcha)" prop="title.kr">
          <el-input v-model="form.title.kr" placeholder="Qoraqalpoq tilidagi sarlavha" />
        </el-form-item>

        <el-form-item
          label="Havola (URL)"
          prop="link"
          :rules="[{ required: true, message: 'Havolani kiriting' }]"
        >
          <el-input v-model="form.link" placeholder="https://lex.uz/docs/..." />
        </el-form-item>

        <div class="form-actions">
          <router-link to="/app/legal-documents" class="el-button el-button--danger">
            Bekor qilish
          </router-link>
          <el-button type="primary" :loading="submitLoading" @click="submitForm">
            Saqlash
          </el-button>
        </div>
      </el-form>
    </el-col>
  </el-row>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { ElMessage, ElNotification } from "element-plus";
import http from "@/http";
import router from "@/router";
import { useRoute } from "vue-router";

const route = useRoute();
const { id } = route.params;

const formRef = ref();
const loading = ref(false);
const submitLoading = ref(false);

const form = reactive({
  title: { uz_lat: "", ru: "", en: "", uz_cyr: "", kr: "" },
  link: "",
});

const submitForm = () => {
  if (!formRef.value) return;
  formRef.value.validate((valid, fields) => {
    if (!valid) {
      Object.values(fields)
        .flat()
        .forEach((e) => ElMessage.error(e.message));
      return;
    }
    submitLoading.value = true;
    const url = id ? `api/v1/legal-documents/${id}` : "api/v1/legal-documents";
    const method = id ? "put" : "post";
    http({ url, data: { title: form.title, link: form.link }, method })
      .then(() => {
        ElMessage({ type: "success", message: "Muvaffaqqiyatli saqlandi" });
        router.push("/app/legal-documents");
      })
      .catch(({ response }) => {
        ElNotification.error({
          message: response?.data?.message || "Xatolik, qayta urinib ko'ring",
        });
      })
      .finally(() => {
        submitLoading.value = false;
      });
  });
};

onMounted(() => {
  if (!id) return;
  loading.value = true;
  http
    .get(`api/v1/legal-documents/${id}`)
    .then(({ data }) => {
      form.title.uz_lat = data.title?.uz_lat || "";
      form.title.ru = data.title?.ru || "";
      form.title.en = data.title?.en || "";
      form.title.uz_cyr = data.title?.uz_cyr || "";
      form.title.kr = data.title?.kr || "";
      form.link = data.link || "";
    })
    .catch(() => {
      ElMessage.error("Ma'lumot yuklashda xatolik!");
    })
    .finally(() => {
      loading.value = false;
    });
});
</script>

<style scoped lang="scss">
.form-title {
  margin-bottom: 20px;
  font-weight: 600;
}
.legal-form {
  max-width: 600px;
}
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  a {
    text-decoration: none;
  }
}
</style>
